import { Component, Input, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';

import { PlayerDetailsRaces, PlayerIncidentsItem } from '../../service/player.service';

interface IncidentRow {
    day_real?: string;
    circuits_name?: string;
    description?: string;
}

/**
 * Read-only list of a driver's incidents. The raw incidents only carry a
 * raceday_id, so we join them to the race list to recover the date and circuit.
 */
@Component({
    selector: 'app-member-incidents',
    standalone: true,
    templateUrl: './memberIncidents.component.html',
    styleUrls: ['./memberIncidents.component.scss'],
    imports: [CommonModule, TableModule],
})
export class MemberIncidentsComponent implements OnChanges {
    @Input() incidents: PlayerIncidentsItem[] = [];
    @Input() races: PlayerDetailsRaces[] = [];

    rows: IncidentRow[] = [];

    ngOnChanges(): void {
        // Map each raceday to its date/circuit (first race of that day wins).
        const byRaceday = new Map<number, PlayerDetailsRaces>();
        for (const race of this.races) {
            if (race.raceday_id != null && !byRaceday.has(race.raceday_id)) {
                byRaceday.set(race.raceday_id, race);
            }
        }

        this.rows = this.incidents.map((incident) => {
            const race = incident.raceday_id != null ? byRaceday.get(incident.raceday_id) : undefined;
            return {
                day_real: race?.day_real,
                circuits_name: race?.circuits_name,
                description: incident.description,
            };
        });
    }
}
